import { Typography, DialogTitle, styled } from "@mui/material"

export const StyledClassroomInfoText = styled(Typography)`
  color: black;
`
export const StyledDialogTitle = styled(DialogTitle)`
  color: black;
`
